var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShareIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.5 8V19C3.5 21.201 5.294 22 6.5 22H21.5V20H6.512C6.05 19.988 5.5 19.806 5.5 19C5.5 18.194 6.05 18.012 6.512 18H21.5V4C21.5 2.897 20.603 2 19.5 2H6.5C5.294 2 3.5 2.799 3.5 5V8ZM6.5 4H19.5V16H5.5V5C5.5 4.194 6.05 4.012 6.5 4Z",
    fill: "#6F6F6F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4973 14.0004L15.8473 10.7114C16.0539 10.5127 16.2182 10.2744 16.3304 10.0107C16.4427 9.74705 16.5005 9.46343 16.5005 9.17685C16.5005 8.89028 16.4427 8.60666 16.3304 8.34298C16.2182 8.0793 16.0539 7.841 15.8473 7.64235C15.4309 7.23136 14.8694 7.00091 14.2843 7.00091C13.6993 7.00091 13.1377 7.23136 12.7213 7.64235L12.4973 7.86035L12.2733 7.64135C11.8571 7.23042 11.2957 7 10.7108 7C10.1259 7 9.56456 7.23042 9.14833 7.64135C8.94178 7.84 8.77746 8.0783 8.66522 8.34198C8.55297 8.60566 8.49512 8.88928 8.49512 9.17585C8.49512 9.46243 8.55297 9.74605 8.66522 10.0097C8.77746 10.2734 8.94178 10.5117 9.14833 10.7104L12.4973 14.0004Z",
    fill: "#6F6F6F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShareIcon);
export default __webpack_public_path__ + "static/media/shareIcon.cbf10004446f658942c6a3f05abc29e0.svg";
export { ForwardRef as ReactComponent };